<taly-banner />

<div class="container">
    <taly-features />
    <taly-how-it-work />
    <taly-partners />
    
    <taly-home-faq />
    <taly-app-details />
    <taly-taly-business />

</div>